import React, { ReactNode } from 'react';
import TopBar from './TopBar';
import Composer from './Composer';
import { cn } from '@/lib/utils';

interface PageLayoutProps {
  children: ReactNode;
  showComposer?: boolean;
  hidePostButtons?: boolean;
  hideTopBar?: boolean; // Hide TopBar component (keep composer)
  mode?: 'all' | 'chrono';
  onModeChange?: (m: 'all' | 'chrono') => void;
  categories?: string[];
  category?: string;
  onCategoryChange?: (c: string) => void;
  onCreate?: (text: string, file?: File) => Promise<void>;
  showRefresh?: boolean;
  onRefresh?: () => void;
  onTagSelect?: (tag: string) => void;
  onCompose?: () => void;
  transparentHeader?: boolean;
  hideHeader?: boolean;
  viewModeButtons?: ReactNode; // View mode toggle buttons to display in header
  pageTitle?: string; // Title to display in the header
}

const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  showComposer = false,
  hidePostButtons = false,
  mode,
  onModeChange,
  categories,
  category,
  onCategoryChange,
  onCreate,
  showRefresh,
  onRefresh,
  onTagSelect,
  onCompose,
  transparentHeader = false,
  hideHeader = false,
  hideTopBar = false,
  viewModeButtons,
  pageTitle,
}) => {
  return (
    <div className="flex min-h-screen w-full max-w-full flex-col bg-[#1A1A1B] overflow-x-hidden">
      {!hideHeader && (
        <>
          <TopBar onTagSelect={onTagSelect} />
          <Composer 
            showComposer={showComposer} 
            hidePostButtons={hidePostButtons} 
            mode={mode} 
            onModeChange={onModeChange} 
            categories={categories} 
            category={category} 
            onCategoryChange={onCategoryChange} 
            onCreate={onCreate} 
            showRefresh={showRefresh} 
            onRefresh={onRefresh} 
            onCompose={onCompose} 
            viewModeButtons={viewModeButtons} 
          />
        </>
      )}
      <main 
        className="flex-1 w-full max-w-full overflow-x-hidden"
        style={{
          // Header is sticky (occupies layout space) and composer is fixed.
          // We no longer need extra top padding; remove to avoid global gap.
          paddingTop: '0'
        }}
      >
        {children}
      </main>
    </div>
  );
};

export default PageLayout;